export * from './sidebar-detail.component';